import { useCallback, useState } from 'react';
import { Step } from './CreatePartnerOrganization.enum';
import useSocket from '@/hooks/useSocket.ts';

export const useCreatePartnerOrganization = () => {
    useSocket();
    const [currentStep, setCurrentStep] = useState<Step>(Step.ONBOARDING);

    const handleNext = useCallback(() => {
        setCurrentStep((prev) =>
            prev === Step.ONBOARDING
                ? Step.CREATE_ORGANIZATION
                : Step.AGENT_SETUP
        );
    }, []);

    const handleBack = useCallback(() => {
        setCurrentStep((prev) =>
            prev === Step.AGENT_SETUP
                ? Step.CREATE_ORGANIZATION
                : Step.ONBOARDING
        );
    }, []);
    return {
        currentStep,
        handleBack,
        handleNext
    };
};
